import ParkingSVG from "@design-system/ui-icons/vanilla/Parking"
import { createIcon } from "../createIcon"

export const ParkingIcon = createIcon(ParkingSVG)
